const formatTaxonomyList = function (list) {
	if (Array.isArray(list)) {
		const formatter = new Intl.ListFormat('en-US', {
			style: 'long',
			type: 'conjunction',
		});

		return formatter.format(list.map(item => item.name));
	}

	return list;
};

export default formatTaxonomyList;
